import { AgentSearchStatus } from "app/pages/AgentSearch/modules/AgentItemsList/state";
import { AgentSearchResult } from "app/shared/model";

export enum ActionType {
    PageLoaded = 'AgentSearch/PageLoaded',
    ChangeSearchTerm = 'AgentSearch/ChangeSearchTerm',
    ChangeSearchStatus = 'AgentSearch/ChangeSearchStatus',
    AgentSearchResult = 'AgentSearch/AgentSearchResult',
    Other = '__OTHER__'
}

export type PageLoadedEvent = {
    type: ActionType.PageLoaded
    searchTerm: string, 
    agents: AgentSearchResult[]
}

export type ChangeSearchStatusEvent = {
    type: ActionType.ChangeSearchStatus, 
    status: AgentSearchStatus
}

export type AgentSearchResultEvent = {
    type: ActionType.AgentSearchResult, 
    agents: AgentSearchResult[]
}

export type ChangeSearchTermEvent = {
    type: ActionType.ChangeSearchTerm,
    searchTerm: string
}

export type OtherAction = {
    type: ActionType.Other
}

export type Action =
PageLoadedEvent 
| ChangeSearchTermEvent
| ChangeSearchStatusEvent
| AgentSearchResultEvent
| OtherAction